import React, { ReactElement, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { DropdownListPortalOverlay } from "./style";
import { useEscKeyCloseInModal } from "hooks/useEscKeyCloseInModal";

const DropdownListPortal = ({
  children,
  onClose,
}: {
  children: ReactElement;
  onClose: () => void;
}) => {
  const portalRef = useRef<HTMLDivElement>(null);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onClose();
  };

  // useEffect(() => {
  //   Util.handleObjectClose(portalRef, () => onClose(), {
  //     wheelBlock: true,
  //     resize: true,
  //   });
  // }, [onClose]);

  const el = document.getElementById("list-root");

  useEscKeyCloseInModal(portalRef, onClose);

  if (el) {
    return ReactDOM.createPortal(
      <DropdownListPortalOverlay
        onClick={handleClick}
        onWheel={(e) => e.stopPropagation()}
      >
        <div
          ref={portalRef}
          className="portal-content"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          {portalRef.current && children}
        </div>
      </DropdownListPortalOverlay>,
      el
    );
  } else {
    return <>{children}</>;
  }
};

export default DropdownListPortal;
